import {
  Box,
  Button,
  Grid,
  Divider,
  Modal,
  Card,
  Stack,
  Typography,
  Skeleton,
  IconButton,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import * as React from "react";
import axios from "axios";
import {
  Dropzone,
  FileMosaic,
  FullScreen,
  ImagePreview,
  //   createSyntheticFile,
  //   uploadFile,
} from "@files-ui/react";
import { useBulkOCR } from "../context/BulkOCRContext";
import useOCRPolling from "../hooks/useOCRPolling";
import CloseIcon from "@mui/icons-material/Close";
import OCRGroupCard from "./OCRGroupCard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LooksOneIcon from "@mui/icons-material/LooksOne";
import LooksTwoIcon from "@mui/icons-material/LooksTwo";
import Looks3Icon from "@mui/icons-material/Looks3";
import Looks4Icon from "@mui/icons-material/Looks4";
import OCRDemoDialog from "./OCRDemoDialog";
import InfoIcon from "@mui/icons-material/Info";

const BulkOCRModal = ({
  open,
  setOpen,
  usage,
  genreList,
  developer,
  token,
  llmList,
  getUsageFn,
  markingSchemeList,
}) => {
  const { state, dispatch } = useBulkOCR();
  console.log("state", state);
  const { massId } = state;
  console.log("massId", massId);
  const [uploadImages, setUploadImages] = React.useState([]);
  const [error, setError] = React.useState("");
  const [genre, setGenre] = React.useState("");
  const [topic, setTopic] = React.useState("");
  const [markingScheme, setMarkingScheme] = React.useState("");
  const [expandedAccordion, setExpandedAccordion] = React.useState("panel1");
  const [AILoading, setAILoading] = React.useState(false);
  const [tempText, setTempText] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState(0);
  const [llm, setLlm] = React.useState("Grok-3");
  const [emptyError, setEmptyError] = React.useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [openGuideDialog, setOpenGuideDialog] = React.useState(false);

  const [gpt4usage, setGpt4Usage] = React.useState(0);
  const [submitLoading, setSubmitLoading] = React.useState(false);
  const [submitSuccess, setSubmitSuccess] = React.useState(false);
  React.useEffect(() => {
    setGpt4Usage(usage?.gpt4);
  }, [usage]);

  const totalGroups = state.groups ? state.groups.length : 0;
  const handlePrev = () => setCurrentPage((prev) => Math.max(prev - 1, 0));
  const handleNext = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalGroups - 1));
  // Reset page if groups change
  React.useEffect(() => {
    if (currentPage >= totalGroups) setCurrentPage(0);
  }, [totalGroups]);

  const shouldPoll = state.groups.length >= 1;
  useOCRPolling(token, shouldPoll);

  const [files, setfiles] = React.useState([]);
  const updateFiles = (incommingFiles) => {
    console.log(incommingFiles);
    setfiles(incommingFiles);
    //setfiles(prevfiles => [...prevfiles, ...incommingFiles])
  };
  const removeFile = (id) => {
    setfiles(files.filter((x) => x.id !== id));
  };
  const [imgSrc, setImgSrc] = React.useState(undefined); // for image preview
  const handleSee = (image) => {
    setImgSrc(image);
  };

  const handleMarkingSchemeChange = (event) => {
    setMarkingScheme(event.target.value);
    dispatch({
      type: "SET_MARKING_SCHEME",
      markingScheme: event.target.value,
    });
  };

  const handleGenreChange = (event) => {
    setGenre(event.target.value);
    dispatch({ type: "SET_GENRE", genre: event.target.value });
  };

  const handleTopicChange = (event) => {
    setTopic(event.target.value);
    //dispatch({ type: "SET_TOPIC", topic: event.target.value });
  };

  const addTextGroup = () => {
    dispatch({
      type: "ADD_GROUP",
      status: "completed",
      text: tempText,
      inputType: "text",
    });
    setTempText("");
    setOpenSnackbar(true);
  };

  //   const [totalFiles, setTotalFiles] = React.useState(
  //     ocrImg.length + files.length
  //   );

  const OCR = async () => {
    if (!files.length) return;
    //const AuthToken = localStorage.getItem("token");
    //let uploadImagesArray = clone(ocrImg);
    let uploadImagesArray = [];
    let uploadFilesArray = [];
    setAILoading(true);

    if (usage && usage?.gpt4 === 0 && usage?.infinite === false && !developer) {
      alert("你已經達到AI使用上限");
      setAILoading(false);
      return;
    }

    /* Image upload */
    let uploadImageName = "temp";
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        uploadImageName = await upLoadImage(files[i]);
        console.log("uploadImageName", uploadImageName);
        uploadImagesArray.push(uploadImageName);
        uploadFilesArray.push(uploadImageName);
      }
    } else {
      alert("Please upload image.");
      setAILoading(false);
      return;
    }

    const response = await axios
      .post(
        `${process.env.REACT_APP_API_HOST}/v2/job/addJob`,
        {
          jobInput: { path: "ocr", icons: uploadFilesArray },
          batchSubmissionID: !massId ? null : massId,
          jobType: "ocr",
        },
        { headers: { Authorization: "Bearer " + token } }
      )
      .catch((error) => {
        console.log("Batch OCR error", error);
        setAILoading(false);
        alert("Batch OCR error: " + error);
        return;
      });
    const data = response?.data;
    if (data.error > 0) {
      setError(data.message);
    }
    console.log("Batch OCR response", data);
    if (!massId) {
      dispatch({ type: "SET_MASS_ID", massId: data?.batchSubmission?._id });
    }
    if (data?.success) {
      dispatch({
        type: "ADD_GROUP",
        id: data.jobID,
        files: uploadFilesArray,
        status: "queued",
        text: "",
        inputType: "ocr",
      });
      setOpenSnackbar(true);
    }
    console.log("Batch OCR response", response);

    if (uploadImagesArray) {
      setUploadImages(uploadImagesArray);
    }
    //setUploadImages(uploadFilesArray);
    setAILoading(false);
    setfiles([]);
  };

  const upLoadImage = async (file) => {
    let fs = new FormData();
    fs.append("image", file.file);

    const response = await axios
      .post(`${process.env.REACT_APP_API_HOST}/v2/image/upload/ocrIcon`, fs, {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": `multipart/form-data`,
        },
      })
      .catch((error) => {
        console.log("upload error", error);
        setAILoading(false);
        alert("upload error: " + error);
        return;
      });
    console.log(response);
    if (response?.data.success) {
      return response.data.name;
    }
  };

  const submitGroupstoBatchMarking = async () => {
    let batchId = massId ? massId : null;
    if (state.groups.length > 0) {
      setSubmitLoading(true);
      for (let i = 0; i < state.groups.length; i++) {
        const group = state.groups[i];
        const input = group.text;
        const status = group.status;
        if (status === "queued" || status === "processing") {
          alert("作文輸入" + (i + 1) + " 正在轉譯中，請稍後再試");
          setSubmitLoading(false);
          return;
        }
        if (input === "") {
          alert("作文輸入" + (i + 1) + " 沒有輸入");
          setSubmitLoading(false);
          return;
        }
      }
      for (let i = 0; i < state.groups.length; i++) {
        const response = await axios
          .post(
            `${process.env.REACT_APP_API_HOST}/v2/job/addJob`,
            {
              jobInput: {
                genre: genre,
                topic: topic,
                marking_scheme: markingScheme,
                type: "flowMark",
                input: state.groups[i].text,
                llm: llm,
                ocrImages: state.groups[i].files,
              },
              batchSubmissionID: batchId ? batchId : null,
              jobType: "callai",
            },
            { headers: { Authorization: "Bearer " + token } }
          )
          .catch((error) => {
            console.log("Batch Marking error", error);
            setAILoading(false);
            alert("Batch Marking error: " + error);
            return;
          });
        if (!batchId) {
          batchId = response?.data?.batchSubmission?._id;
        }
        console.log("Batch Marking response", response);
      }
      await getUsageFn();
      setSubmitLoading(false);
      setSubmitSuccess(true);
    }
  };

  return (
    <Modal open={open}>
      <Grid
        container
        spacing={0}
        justifyContent={"center"}
        sx={{ p: 2 }}
        alignItems={"center"}
      >
        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={() => setOpenSnackbar(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={() => setOpenSnackbar(false)}
            severity="success"
            sx={{ width: "100%", p: 1 }}
          >
            新的作文輸入 {state.groups.length} 已新增！
          </Alert>
        </Snackbar>
        {submitLoading && (
          <Backdrop sx={{ color: "#fff", zIndex: 999 }} open={submitLoading}>
            <CircularProgress color="warning" />
            <Typography variant="h6" color="warning" sx={{ ml: 2 }}>
              正在發送到批改系統進行批改
            </Typography>
          </Backdrop>
        )}
        <Card
          sx={{
            p: { xs: 1, sm: 2, lg: "1% 10%" },
            m: { xs: 1, sm: 2 },
            width: { xs: "100%", lg: "100%" },
            overflow: "auto",
            maxHeight: "90vh",
            borderRadius: "20px",
          }}
        >
          <Stack direction={"row"} alignItems={"center"}>
            <Stack direction="column" spacing={1}>
              <Stack alignItems="flex-start" justifyContent="center">
                <Typography
                  color="text.primary"
                  variant="h5"
                  fontWeight="600"
                  sx={{ mt: 1, mb: 1 }}
                >
                  量批作文評改(測試版)
                </Typography>
              </Stack>
              <Stack direction={"column"} spacing={1} justifyContent="center">
                {usage &&
                usage?.gpt4 < 29 &&
                usage?.infinite === false &&
                !developer ? (
                  <>
                    <Typography variant="Body2" fontWeight="500" sx={{ mb: 2 }}>
                      你的 AI 使用次數剩餘{gpt4usage} 次。
                    </Typography>
                    <Typography variant="Body2" fontWeight="500" sx={{ mb: 2 }}>
                      目前最多可上傳 {gpt4usage} 組作文輸入，每組最多上傳 6
                      張圖片。
                    </Typography>
                  </>
                ) : (
                  <Typography variant="Body2" fontWeight="500" sx={{ mb: 2 }}>
                    最多 30 組作文輸入，每組最多上傳 6 張圖片。
                  </Typography>
                )}
              </Stack>
              {error && (
                <Alert severity="error" sx={{ width: "100%", my: 3 }}>
                  {error}
                </Alert>
              )}
            </Stack>
            <Box sx={{ flexGrow: 1 }} />
            <IconButton
              aria-label="close"
              onClick={() => setOpen(false)}
              sx={{
                color: (theme) => theme.palette.grey[900],
              }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
          <Divider sx={{ mt: 1, mb: 2, pt: 1, pb: 1 }} />
          <Grid container direction={"row"} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <Stack
                direction={"row"}
                alignItems={"center"}
                spacing={0.5}
                sx={{ mt: 1, mb: 2 }}
              >
                <LooksOneIcon />
                <Typography variant="body2" fontWeight={"600"}>
                  請輸入作文題目、文體和評分準則
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Select
                id="markingScheme"
                value={markingScheme}
                disabled={submitSuccess}
                onChange={handleMarkingSchemeChange}
                sx={{ width: "100%" }}
                displayEmpty
              >
                <MenuItem value="">
                  <em>請選擇評分標準</em>
                </MenuItem>
                {markingSchemeList?.map((option) => (
                  <MenuItem
                    key={option.id}
                    value={option.name}
                    disabled={option.disabled}
                  >
                    {option.name}
                  </MenuItem>
                ))}
                {/* <MenuItem value={"TSA"}>TSA</MenuItem>
                <MenuItem value={"Pre-S1"}>Pre-S1</MenuItem>
                <MenuItem value={"DSE"}>DSE</MenuItem>
                <MenuItem value={"IGCSE"}>IGCSE</MenuItem>
                <MenuItem value={"IB"}>IB</MenuItem> */}
              </Select>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Select
                id="genre"
                value={genre}
                disabled={submitSuccess}
                onChange={handleGenreChange}
                sx={{ width: "100%" }}
                displayEmpty
              >
                <MenuItem value="">
                  <em>不指定文體</em>
                </MenuItem>
                {genreList?.map((option) => (
                  <MenuItem
                    key={option.id}
                    value={option.name}
                    disabled={option.disabled}
                  >
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <TextField
              multiline
              fullWidth
              //sx={{ width: "100%", height: "100%", display: "flex" }}
              rows={2}
              placeholder="請輸入作文題目"
              label="作文題目"
              value={topic}
              disabled={submitSuccess}
              onChange={handleTopicChange}
              variant="filled"
            />
          </Grid>
          <Divider sx={{ mt: 1, mb: 2, pt: 1, pb: 1 }} />
          <Stack
            direction={"row"}
            alignItems={"center"}
            spacing={0.5}
            sx={{ mt: 1, mb: 3 }}
          >
            <LooksTwoIcon />
            <Typography variant="body2" fontWeight={"600"}>
              使用OCR或手動輸入文字
            </Typography>
          </Stack>
          <Accordion
            expanded={expandedAccordion === "panel1"}
            onChange={() =>
              setExpandedAccordion(
                expandedAccordion === "panel1" ? false : "panel1"
              )
            }
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography variant="body1" fontWeight={"600"} component="span">
                使用OCR (最多上傳 6 張圖片)
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Stack direction="column">
                <Dropzone
                  onChange={updateFiles}
                  value={files}
                  maxFiles={6}
                  disabled={submitSuccess}
                  //disabled={ocrImg?.length + files?.length > 5 ? true : false}
                  accept=".jpg, .jpeg, .png"
                  label={"拖放或點擊以上傳圖片(最多 6 張圖片)"}
                  behaviour="add"
                >
                  {files.map((file) => (
                    <FileMosaic
                      key={file.id}
                      onDelete={removeFile}
                      {...file}
                      onSee={handleSee}
                      preview
                    />
                  ))}
                </Dropzone>
                <FullScreen
                  open={imgSrc !== undefined}
                  onClose={() => setImgSrc(undefined)}
                >
                  <ImagePreview src={imgSrc} />
                </FullScreen>
                <Typography
                  variant="Body2"
                  fontWeight="500"
                  sx={{ color: "#303030" }}
                >
                  😊請確保圖片中只有清晰的手寫文字，避免拍攝與文章內容無關的部分（像是頁首/頁尾的文字或背景），這樣辨識會更準確！
                </Typography>
                <Typography
                  variant="Body2"
                  fontWeight="500"
                  sx={{ color: "#303030" }}
                >
                  ⚠️注意:手寫辨識的準確度會因書寫方式而有所不同，請盡量書寫清晰工整以達至最佳效果。
                </Typography>
              </Stack>
              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                sx={{ mt: 2 }}
              >
                <Button
                  variant="outlined"
                  color="info"
                  startIcon={<InfoIcon />}
                  sx={{ mb: 2, alignSelf: "flex-end" }}
                  onClick={() => setOpenGuideDialog(true)}
                >
                  查看圖片上傳示例
                </Button>
                <Box sx={{ flexGrow: 1 }} />
                <Button
                  variant="contained"
                  disabled={
                    (gpt4usage >= 30
                      ? state.groups.length === 30
                        ? true
                        : state.groups.length === gpt4usage
                        ? true
                        : false
                      : false) || submitSuccess
                  }
                  sx={{
                    borderRadius: "10px",
                    backgroundColor: "#0071e3",
                    width: { xs: "100%", sm: "auto" },
                    "&:hover": {
                      backgroundColor: "#0071e3",
                    },
                  }}
                  onClick={() => {
                    OCR();
                  }}
                >
                  上傳圖片到作文輸入{" "}
                  {state.groups.length !== 30 ? state.groups.length + 1 : ""}
                </Button>
              </Stack>
            </AccordionDetails>
          </Accordion>
          <OCRDemoDialog
            open={openGuideDialog}
            onClose={() => setOpenGuideDialog(false)}
          />
          <Accordion
            expanded={expandedAccordion === "panel2"}
            onChange={() =>
              setExpandedAccordion(
                expandedAccordion === "panel2" ? false : "panel2"
              )
            }
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2-content"
              id="panel2-header"
            >
              <Typography variant="body1" fontWeight={"600"} component="span">
                或 手動輸入文字
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Stack direction="column">
                <TextField
                  multiline
                  fullWidth
                  rows={18}
                  placeholder="輸入整篇文章以進行評改"
                  label="整篇文章"
                  value={tempText}
                  disabled={submitSuccess}
                  onChange={(e) => setTempText(e.target.value)}
                  variant="filled"
                />
              </Stack>
              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                sx={{ mt: 2 }}
              >
                <Box sx={{ flexGrow: 1 }} />
                <Button
                  variant="contained"
                  disabled={
                    (state.groups.length === 30 ? true : false) || submitSuccess
                  }
                  sx={{
                    borderRadius: "10px",
                    backgroundColor: "#0071e3",
                    width: { xs: "100%", sm: "auto" },
                    "&:hover": {
                      backgroundColor: "#0071e3",
                    },
                  }}
                  onClick={() => {
                    addTextGroup();
                  }}
                >
                  {/* <Trans ns={"passage"} i18nKey={"grading.cancel"} /> */}
                  新增文字到作文輸入{" "}
                  {state.groups.length !== 30 ? state.groups.length + 1 : ""}
                </Button>
              </Stack>
            </AccordionDetails>
          </Accordion>
          <Divider sx={{ mt: 1, mb: 2, pt: 1, pb: 1 }} />
          {state.groups && state.groups.length > 0 && (
            <>
              <Stack
                direction={"row"}
                alignItems={"center"}
                spacing={0.5}
                sx={{ mt: 1, mb: 2 }}
              >
                <Looks3Icon />
                <Typography variant="body2" fontWeight={"600"}>
                  查看OCR文本，修改作文文本
                </Typography>
              </Stack>
              <Stack direction="column" spacing={2}>
                {AILoading ? (
                  <Grid>
                    <Grid item xs={12} sm={12}>
                      <Skeleton
                        variant="rounded"
                        height={50}
                        sx={{ mt: 2, mb: 0, borderRadius: 3 }}
                        //animation="wave"
                      />
                    </Grid>
                  </Grid>
                ) : (
                  <FormControl>
                    {/* <InputLabel id="select-Input-label">作文輸入</InputLabel> */}
                    <Select
                      size="small"
                      value={currentPage}
                      labelId="select-Input-label"
                      onChange={(e) => setCurrentPage(Number(e.target.value))}
                      sx={{ minWidth: 120, mt: 2 }}
                    >
                      {state.groups.map((g, idx) => (
                        <MenuItem key={g.id || idx} value={idx}>
                          作文輸入 {idx + 1}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
                <Stack alignItems="center" spacing={2} sx={{ mt: 3 }}>
                  <Grid container spacing={2} justifyContent="center">
                    <Grid item xs={12}>
                      <OCRGroupCard
                        group={state.groups[currentPage]}
                        index={currentPage}
                        submitSuccess={submitSuccess}
                      />
                    </Grid>
                  </Grid>
                  {AILoading ? (
                    <Grid>
                      <Grid item xs={12} sm={12}>
                        <Skeleton
                          variant="rounded"
                          height={100}
                          sx={{ mt: 1, mb: 0, borderRadius: 5 }}
                          //animation="wave"
                        />
                      </Grid>
                    </Grid>
                  ) : (
                    <>
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Button
                          startIcon={<ArrowBackIcon />}
                          onClick={handlePrev}
                          disabled={currentPage === 0}
                        >
                          上一組
                        </Button>
                        <Typography>
                          {currentPage + 1} / {totalGroups}
                        </Typography>
                        <Button
                          endIcon={<ArrowForwardIcon />}
                          onClick={handleNext}
                          disabled={currentPage === totalGroups - 1}
                        >
                          下一組
                        </Button>
                      </Stack>
                    </>
                  )}
                </Stack>
              </Stack>
            </>
          )}
          {state.groups?.length > 0 && (
            <>
              <Divider sx={{ mt: 1, mb: 2, pt: 1, pb: 1 }} />
              <Stack
                direction={"row"}
                alignItems={"center"}
                spacing={0.5}
                sx={{ mt: 1, mb: 2 }}
              >
                <Looks4Icon />
                <Typography variant="body2" fontWeight={"600"}>
                  完成後請按下「提交批改」按鈕
                </Typography>
              </Stack>
              <Stack direction="column" spacing={2}>
                {llmList && llmList.length > 0 && (
                  <FormControl>
                    <InputLabel id="select-Input-label">
                      請選擇語言模型
                    </InputLabel>
                    <Select
                      size="small"
                      value={llm}
                      disabled={submitSuccess}
                      labelId="select-Input-label"
                      onChange={(e) => setLlm(e.target.value)}
                      sx={{ minWidth: 120, mt: 2 }}
                    >
                      {llmList.map((llm) => (
                        <MenuItem value={llm.value} key={llm.value}>
                          {llm.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
                {submitSuccess && (
                  <Alert
                    severity="success"
                    sx={{ width: "100%", my: 3, p: 2 }}
                    action={
                      <Button
                        color="success"
                        variant="outlined"
                        size="small"
                        onClick={() => {
                          setOpen(false);
                          dispatch({ type: "RESET" });
                          setGenre("");
                          setTopic("");
                          setMarkingScheme("TSA");
                          setSubmitSuccess(false);
                        }}
                      >
                        <Typography variant="body2" fontWeight={"600"}>
                          關閉並重設量批輸入
                        </Typography>
                      </Button>
                    }
                  >
                    <Typography variant="body2" fontWeight={"600"}>
                      批改已提交，請在量批評改紀錄中查看結果。
                    </Typography>
                  </Alert>
                )}
                <Stack direction="row" spacing={2} alignItems="center">
                  <Stack direction="column" spacing={1}>
                    <Typography variant="body2" fontWeight={"600"}>
                      提交批改後，系統會將所有的作文輸入發送到批改系統進行批改，請在量批評改紀錄中查看結果。
                    </Typography>
                    {emptyError && (
                      <Typography
                        variant="body2"
                        fontWeight={"600"}
                        sx={{ color: "red" }}
                      >
                        請輸入作文題目、文體和評分準則
                      </Typography>
                    )}
                  </Stack>
                  <Box sx={{ flexGrow: 1 }} />
                  <Button
                    variant="contained"
                    disabled={submitSuccess}
                    sx={{
                      borderRadius: "10px",
                      backgroundColor: "#0071e3",
                      width: { xs: "100%", sm: "auto" },
                      "&:hover": {
                        backgroundColor: "#0071e3",
                      },
                    }}
                    onClick={() => {
                      if (
                        !topic ||
                        topic === "" ||
                        !markingScheme ||
                        markingScheme === "" ||
                        !genre ||
                        genre === ""
                      ) {
                        setEmptyError(true);
                        return;
                      } else {
                        setEmptyError(false);
                        submitGroupstoBatchMarking();
                      }
                    }}
                  >
                    提交批改
                  </Button>
                </Stack>
              </Stack>
            </>
          )}
          {/* {!AILoading && (
            <>
              <Grid container direction={"column"} spacing={2}>
                <Grid item xs={12}>
             
                  <TextField
                    multiline
                    label={ocrWriting === "" ? "請上傳圖片" : "請修改作文"}
                    rows={20}
                    sx={{
                      mt: 2,
                      mb: 2,
                      backgroundColor: "#F0F0F0",
                      ".MuiInputBase-root": {
                        fontSize: "20px !important",
                        passingBottom: "20px !important",
                      },
                      ".MuiInput-root": {
                        height: " 20px !important",
                      },
                    }}
                    fullWidth
                    disabled={ocrWriting == ""}
                    variant="outlined"
                    value={ocrWriting}
                    //disabled={submitSuccess ? true : false}
                    onChange={(e) => setOcrWriting(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Box sx={{ flexGrow: 1 }} />
                  
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: "10px",
                      backgroundColor: "#0071e3",
                    }}
                    disabled={ocrWriting == ""}
                    onClick={() => {
                      if (ocrWriting !== "") {
                        setText(
                          text !== ""
                            ? text + "-----------------------\n" + ocrWriting
                            : ocrWriting
                        );
                        setOcrImages(uploadImages);
                        setOpen(false);
                      } else {
                        alert("請輸入作文");
                      }
                    }}
                  >
                    保存修改
                  </Button>
                </Stack>
              </Grid>
            </>
          )} */}
        </Card>
      </Grid>
    </Modal>
  );
};

export default BulkOCRModal;
